// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/employee-allowances",
  Create: "/pyr/employee-allowances",
  Update: "/pyr/employee-allowances",
};
